import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import SandtonSpecialists from "./sections/SandtonSpecialists";
import WhyItsATouchOfLove from "./sections/WhyItsATouchOfLove";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <SandtonSpecialists />
      <WhyItsATouchOfLove />
      <Footer />
    </div>;
}